export default __webpack_public_path__ + "static/media/express.e45c523d.png";